import { render, staticRenderFns } from "./orderXq.vue?vue&type=template&id=b12b90f2&scoped=true"
import script from "./orderXq.vue?vue&type=script&lang=js"
export * from "./orderXq.vue?vue&type=script&lang=js"
import style0 from "./orderXq.vue?vue&type=style&index=0&id=b12b90f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12b90f2",
  null
  
)

export default component.exports